import { createSelector } from 'reselect';
import { RootState } from '../../../types';
import { EntityTypes } from '../../../constants/entities';
import { IHistoryItem, IRegisterReducer } from 'core/slices/register';
import { Mode } from 'core/slices/session';
import { selectSessionMode } from '../admin/sessionMode';
import { IStateReducer } from 'core/reducers/state';

const register = (state: RootState) => state.register;
const state = (state: RootState) => state.state;
const mode = selectSessionMode;

export interface IFeed {
  feed: IHistoryItem[];
}

export const selectFeed = createSelector([register,  mode, state], parseFeed);

export function parseFeed(register: IRegisterReducer, mode: Mode, state: IStateReducer) {

  return {
    feed:
      register.queue[
        mode === Mode.PREVIEW
          ? `.${state[EntityTypes.COURSE_PROGRESS]}`
          : `${state[EntityTypes.TOKEN]}.${state[EntityTypes.COURSE_PROGRESS]}`
      ] || [],
  } as IFeed;
}
